<template>
    <ModalComponent
        name="cargarProductosEventoAnterior"
        title="Cargar productos de evento anterior"
        @opened="getEvents"
        v-on:close="() => close(false)"
    >

        <ContentOrLoading>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit" v-if="events && !loading">
                <div>
                    <label for="old_event">Evento</label>
                    <multiselect
                        id="old_event"
                        v-model="old_event"
                        placeholder="Seleccionar evento"
                        label="name"
                        track-by="id"
                        :options="events"
                        :multiple="false"
                        :max-height="130"
                    />
                </div>
                <div class="mt-3" v-if="old_event?.sesiones">
                    <label for="old_sesion">Sesión</label>
                    <multiselect
                        id="old_sesion"
                        v-model="old_sesion"
                        placeholder="Seleccionar sesión"
                        track-by="id"
                        :custom-label="customLabel"
                        :options="Object.values(old_event.sesiones)"
                        :multiple="false"
                        :max-height="130"
                    />
                </div>
                <Button class="mt-4" :disabled="!old_event || !old_sesion" @click="cargar">Cargar</Button>
            </ValidationObserver>
        </ContentOrLoading>            
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";
    import ContentOrLoading from '../../../../components/ContentOrLoading.vue';

    export default {
        data() {
            return {
                events: [],
                loading: true,
                old_event: null,
                old_sesion: null
            }
        },
        methods: {
            close() {
                this.old_event = null;
                this.$emit('close', 'cargarProductosEventoAnterior');
            },
            getEvents : function() {
                this.loading = true;
                const data = {
                    filters: {
                        per_page: 100,
                        page: 1,
                        search: '',
                        to_select: true,
                        with_products: true,
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                    this.events = res.data.data;
                    this.loading = false
                });
            },
            customLabel(sesion) {
                var texto = sesion.session_date;

                if (sesion.text) {
                    texto += (' - ' + sesion.text)
                }

                return texto; 
            },
            cargar(){
                this.$emit('cargarProductos', this.old_event, this.old_sesion);
                this.close();
            }
        },
        components: {
            ModalComponent, ContentOrLoading
        }
    }
</script>

        